import { LoadableBackground } from '@confluence/loadable';

export const InlineCommentNudge = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-InlineCommentNudge" */ './InlineCommentNudge.tsx'))
			.InlineCommentNudge,
});
